class Accordion {
    constructor(collection, _settings = {}) {
        if (collection.length === 0) { return; }

        this.props = {
            collection,
            settings: {
                closeOther: true,
                handleSelector: '.js-accordion__handle',
                containerSelector: '.js-accordion__content',
                ..._settings
            }
        }

        this.props.collection.forEach(this.initAccordion.bind(this));
    }

    initAccordion(element) {
        const handle = element.querySelector(this.props.settings.handleSelector);
        const content = element.querySelector(this.props.settings.containerSelector);

        if (!handle || !content) { return; }

        handle.addEventListener("click", event => {
            event.preventDefault();

            if (!element.classList.contains('is-open')) {
                if (this.props.settings.closeOther) {
                    this.closeAccordions();
                }
                jQuery(content).slideDown(500);
            } else {
                jQuery(content).slideUp(500);
            }

            element.classList.toggle('is-open');
        });
    }

    closeAccordions() {
        this.props.collection.forEach(element => {
            const content = element.querySelector(this.props.settings.containerSelector);
            if (!content) { return; }
            element.classList.remove('is-open');
            jQuery(content).slideUp(500);
        });
    }
}

export default Accordion;


// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/accordion.js